let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aGdjj")).then(() => parcelRequire('cgNt3'));